import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import ContentEditable from '../ReactContenteditable.js';
import maxWidthMemo from '../maxWidthMemo.js';
export default (function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      tagName = _ref.tagName,
      className = _ref.className;

  var moduleClassName = className;

  function TextModule(_ref2) {
    var children = _ref2.children,
        _ref2$content = _ref2.content,
        content = _ref2$content === void 0 ? '' : _ref2$content,
        className = _ref2.className,
        style = _ref2.style,
        edit = _ref2.edit,
        _ref2$editable = _ref2.editable,
        editable = _ref2$editable === void 0 ? {} : _ref2$editable,
        _ref2$uiEvents = _ref2.uiEvents,
        uiEvents = _ref2$uiEvents === void 0 ? null : _ref2$uiEvents;

    var _ref3 = style || {},
        maxWidth = _ref3.maxWidth,
        inlineStyles = _objectWithoutPropertiesLoose(_ref3, ["maxWidth"]);

    var maxWidthStyle = maxWidthMemo(maxWidth);

    if (process.env.ENV_RAW || !edit) {
      var TagName = tagName;
      return /*#__PURE__*/React.createElement("div", {
        key: "tb",
        className: className,
        style: inlineStyles
      }, /*#__PURE__*/React.createElement(TagName, {
        className: moduleClassName,
        dangerouslySetInnerHTML: {
          __html: content
        },
        style: maxWidthStyle
      }));
    }

    return /*#__PURE__*/React.createElement("div", Object.assign({
      key: "tb",
      className: className,
      style: inlineStyles
    }, uiEvents), /*#__PURE__*/React.createElement("div", {
      className: moduleClassName,
      style: maxWidthStyle
    }, /*#__PURE__*/React.createElement(ContentEditable, Object.assign({
      tagName: tagName,
      html: content
    }, editable))), children);
  }

  TextModule.className = moduleClassName + '-box';
  return TextModule;
});